export default __webpack_public_path__ + "static/media/bg-2.aa6f8038.jpg";